import {
  ICATPLUS_GET_EXP_REPORTS,
  useGetEndpoint,
} from '@edata-portal/icat-plus-api';
import { Card } from 'react-bootstrap';

import { type DOI } from '../utils/doi';
import { ReportButton } from './ReportButton';
import { ReportText } from './ReportText';

export function LoadReports({ doi }: { doi: DOI }) {
  const reportFiles = useGetEndpoint({
    endpoint: ICATPLUS_GET_EXP_REPORTS,
    params: { doi: doi.doi.toUpperCase() },
  });

  if (!reportFiles || reportFiles.length === 0) {
    return null;
  }

  return (
    <>
      {reportFiles.map((dataReport) => (
        <Card.Body key={dataReport.proposal} className="p-2">
          <ReportText dataReport={dataReport} />

          {!dataReport.underEmbargo && (
            <div className="d-flex flex-wrap gap-2">
              {dataReport.reports.map((report) => (
                <ReportButton
                  key={report}
                  file={report}
                  proposal={dataReport.proposal}
                />
              ))}
            </div>
          )}
        </Card.Body>
      ))}
    </>
  );
}
